import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthService as AuthGuard } from './auth.service'
import { IntroductionComponent } from './introduction/introduction.component';
import { Deactivate1Component } from './deactivate1/deactivate1.component';
import { FaqComponent } from './faq/faq.component';
import { LoginComponent } from './login/login.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { DialogboxComponent } from './dialogbox/dialogbox.component';
import { GetdataComponent } from './getdata/getdata.component';
import { FailmodalComponent } from './failmodal/failmodal.component';
import { DownloadComponent } from './download/download.component';
import { DefaultLayoutComponent } from './default-layout/default-layout.component';
import { NewAppComponent } from './new-app/new-app.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { KycdisplayComponent } from './kycdisplay/kycdisplay.component';

const routes: Routes = [
  {path :'',redirectTo :"Introduction",pathMatch :'full'},
  // {path:'Introduction',component:IntroductionComponent},
  // {path: 'Deactivate' ,component:DeactivateComponent},  //deactivate
  // {path:'Deactivate',component:Deactivate1Component},   //deactivate1
  // {path:'Faq',component:FaqComponent},
  // {path: 'login' , component : LoginComponent},
  // {path: 'feedback' , component : FeedbackComponent},
  // {path: 'authenticate/:id', component: Lo},
  {path: 'dialogbox', component:DialogboxComponent },
  {path: 'myTransactions', component:GetdataComponent,canActivate:[AuthGuard]  },
  {path: 'MyData' ,component:KycdisplayComponent,canActivate:[AuthGuard]  },
  {path: 'authenticationfailed', component:FailmodalComponent ,canActivate:[AuthGuard] },
  // {path:'Download',component:DownloadComponent},
  // {path:'defaultLayout',component:DefaultLayoutComponent},

   {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      // title: 'Home'
    },
    children: [
      {path: 'login', component: LoginComponent},
      {path:'Download',component:DownloadComponent},
      { path: 'Faq', component: FaqComponent },
      { path: 'Privacy-Policy', component: PrivacyPolicyComponent },
      {path: 'Terms&Conditions', component: TermsConditionsComponent},
      {path: 'feedback' , component : FeedbackComponent},
      {path:'Delete',component:Deactivate1Component},
      {path:'Introduction',component:IntroductionComponent},
      {path:'new-app',component:NewAppComponent},
    ]
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingcomponent = RouterModule.forRoot(routes,{useHash:true,scrollPositionRestoration: "top",
anchorScrolling: "enabled",
enableTracing: false,onSameUrlNavigation: 'reload' });
